module.exports = __webpack_public_path__ + "img/activities-7.47960f31.jpg";